<template lang="html">
  <clip-loader loading class="loader" />
</template>

<script setup>
import ClipLoader from "vue-spinner/src/ClipLoader.vue"
</script>
